import axios from 'axios';
import { showAlert } from './alerts';
export const sendContact = async (form, isMobile, turnstileToken) => {

  if (!turnstileToken || typeof turnstileToken !== "string" || turnstileToken.length > 2048) {
    showAlert('error', 'Please complete the security verification');
    return;
  }
const email = form.email;
const companyName = form.companyName;
const country = form.country;
const message = form.message;
const name = form.name;
const phone= form.phone;
const way = form.way;
// const serverBaseDomain = "http://localhost:3000";
const serverBaseDomain = "https://cserver.zirveextrusion.net";
    var filter = /^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/;
        if (!filter.test(email)) {
            showAlert('error', 'invalid email');
            return;
        }
        if(!name || name == ''){
            showAlert('error', 'invalid name');
            return;
        }
        if(!phone || phone == ''){
            showAlert('error', 'invalid phone');
            return;
        }
        if(!message || message == ''){
            showAlert('error', 'invalid message');
            return;
        }
    const errorMap = ["Invalid number", "Invalid country code", "Too short", "Too long", "Invalid number"];
    try {
      var p;
      var c;
      // var dialCode = '';
      if(isMobile){
        var number = $("#phone_m").intlTelInput('getNumber');
        var iso = $("#phone_m").intlTelInput('getSelectedCountryData').iso2;
        var isValidNumber = intlTelInputUtils.isValidNumber(number, iso);
        var validationError = intlTelInputUtils.getValidationError(number, iso);
        if(!isValidNumber){
          showAlert('error', errorMap[validationError] || 'Please check the phone number');
          return;
        }
        p = number;
        c = iso;
        // dialCode = $("#phone_m").intlTelInput('getSelectedCountryData').dialCode;
      }
      if(!isMobile){
        var number = $("#phone").intlTelInput('getNumber');
        var iso = $("#phone").intlTelInput('getSelectedCountryData').iso2;
        var isValidNumber = intlTelInputUtils.isValidNumber(number, iso);
        var validationError = intlTelInputUtils.getValidationError(number, iso);
        if(!isValidNumber){
          showAlert('error', errorMap[validationError] || 'Please check the phone number');
          return;
        }
        p = number;
        c = iso;
        // dialCode = $("#phone").intlTelInput('getSelectedCountryData').dialCode;
      }
      var formattedNumber = intlTelInputUtils.formatNumber(number, iso, intlTelInputUtils.numberFormat.NATIONAL);
      var intNumber = intlTelInputUtils.formatNumber(number, iso, intlTelInputUtils.numberFormat.INTERNATIONAL);
      var e164Number = intlTelInputUtils.formatNumber(number, iso, intlTelInputUtils.numberFormat.E164);
      const dialCode = intNumber.split(' ')[0] || '';
      const nationalPhone = {
        countryCode: iso,
        dialCode: dialCode,
        e164Number: e164Number,
        internationalNumber: intNumber,
        nationalNumber: formattedNumber,
        number: number,
      }
      const res = await axios({
        method: 'POST',
        url: `${serverBaseDomain}/front/api/contact-us`,
        data: { email ,companyName ,country ,message ,name ,phone ,way , full_phone: p, countryCode: c, nationalPhone, turnstileToken}
      });
      if (res.data.status) {
        showAlert('success', res.data.message);
        isMobile ? $("#contact_m")[0].reset() : $("#contact")[0].reset() ;
      //     window.setTimeout(() => {
      //       location.assign('/');
      //     }, 1500);
      }
    } catch (err) {
      console.log('error', err)
      showAlert('error', err?.response?.data?.message || 'Sorry something went wrong please try again later, thank you.');
    }
  };